import React from 'react'
import { List, Skeleton } from '@fs/zion-ui'
import SkeletonAnimationSyncDecorator from '../../../common/SkeletonAnimationSyncDecorator'

export default function SearchRecordsLoading(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <List>
        <Skeleton.ListItem dense hasIcon />
        <Skeleton.ListItem dense hasIcon />
        <Skeleton.ListItem dense hasIcon />
        <Skeleton.ListItem dense hasIcon />
        <Skeleton.ListItem dense hasIcon />
        <Skeleton.ListItem dense hasIcon />
      </List>
    </SkeletonAnimationSyncDecorator>
  )
}
